'use client'
import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import { IGallery } from '@/_types'

const GalleryPage = ({
  data,
  count,
}: {
  data: IGallery[]
  count: string | number
}) => {
  const isDesktop = useIsDesktop()

  return isDesktop ? (
    <Desktop data={data} count={count} />
  ) : (
    <Mobile data={data} count={count} />
  )
}

export default GalleryPage
